import React from "react";
import { Box, Skeleton } from "@mui/material";

const TableLoadingOverlay = ({ columnCount = 5, rowCount = 10 }) => {
  const safeColumns = Math.max(1, Number(columnCount) || 1);
  const safeRows = Math.max(3, Number(rowCount) || 10);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: `repeat(${safeColumns}, minmax(0, 1fr))`,
          gap: 1,
        }}
      >
        {Array.from({ length: safeColumns }).map((_, index) => (
          <Skeleton
            key={`header-${index}`}
            variant="rectangular"
            height={28}
            animation="wave"
            sx={{ borderRadius: 1 }}
          />
        ))}
      </Box>
      <Box
        sx={{
          flex: 1,
          display: "grid",
          gridTemplateColumns: `repeat(${safeColumns}, minmax(0, 1fr))`,
          gap: 1,
          alignContent: "start",
          overflow: "hidden",
        }}
      >
        {Array.from({ length: safeRows }).map((_, rowIndex) =>
          Array.from({ length: safeColumns }).map((_, colIndex) => (
            <Skeleton
              key={`cell-${rowIndex}-${colIndex}`}
              variant="rectangular"
              height={24}
              animation="wave"
              sx={{ borderRadius: 1 }}
            />
          ))
        )}
      </Box>
    </Box>
  );
};

export default TableLoadingOverlay;
